import FechamentoPeriodo from "views/admin/relatorio/FechamentoPeriodo.js";
import RelatorioIA from "./views/admin/relatorio/RelatorioIA.js";
import RelatorioIRD from "./views/admin/relatorio/RelatorioIRD.js";

var routes = [
  {
    path: "/FechamentoPeriodo",
    name: "Fechamento de Período",
    icon: "",
    component: FechamentoPeriodo,
    layout: "/blank",
    sidebar: false
  },
    {
    path: "/RelatorioIRD",
    name: "Relatório IRD",
    icon: "",
    component: RelatorioIRD,
    layout: "/blank",
    sidebar: false
  },
  {
    path: "/RelatorioIA",
    name: "Relatório IA",
    icon: "",
    component: RelatorioIA,
    layout: "/blank",
    sidebar: false
  },
];

export default routes;
